import { DataLayer } from '@by-miles/data-layer'
import { useEffect, useState } from 'react'

import { VehicleAddressInput } from '../../../../../../../generated/graphql'
import { useQuote } from '../../../../../../../hooks/useQuote'
import { useCarPageContext } from '../../../../../../../pages/CarPageProvider'
import { usePreQuoteContext } from '../../../../../../../pages/PageValidator'
import { Address } from '../Address'

export const AddressContainer = () => {
  const quote = useQuote()
  const { handleUpdateCarDetails } = useCarPageContext()
  const { showErrorBanner, notAnsweredMessage, updateValidInputs, validInputs } = usePreQuoteContext()

  const [parkedAtHome, setParkedAtHome] = useState<boolean | undefined | null>(quote?.details?.vehicle?.is_parked_home)
  const [customAddress, setCustomAddress] = useState<VehicleAddressInput>({
    postcode: quote?.details?.vehicle?.address?.postcode || '',
  })

  const handleParkedAtHome = (is_parked_home: boolean) => {
    setParkedAtHome(is_parked_home)
    DataLayer.customEvent({
      eventName: `parked home ${is_parked_home ? 'yes' : 'no'}`,
      section: 'car',
      eventType: 'form tracking',
    })
    handleUpdateCarDetails({ is_parked_home })
  }

  const handleCustomAddress = (postcode?: string | null | undefined) => {
    setCustomAddress({ postcode: postcode || '' })
    DataLayer.customEvent({
      eventName: 'home address',
      section: 'car',
      eventType: 'form tracking',
    })
    handleUpdateCarDetails({ address: { postcode: postcode || '' } })
  }

  useEffect(() => {
    updateValidInputs({ field: 'parkedAtHome', value: typeof parkedAtHome === 'boolean' })
    updateValidInputs({ field: 'postcode', value: !(parkedAtHome === false && !customAddress.postcode) })
  }, [parkedAtHome])
  useEffect(() => {
    updateValidInputs({ field: 'postcode', value: parkedAtHome !== false || !!customAddress.postcode })
  }, [customAddress])

  return (
    <Address
      showErrorBanner={showErrorBanner}
      notAnsweredMessage={notAnsweredMessage}
      parkedAtHome={parkedAtHome}
      handleParkedAtHome={handleParkedAtHome}
      customAddressPostcode={customAddress?.postcode}
      handleCustomAddress={handleCustomAddress}
      postcodeValid={validInputs?.postcode}
    />
  )
}
